<ng-template [vbCssRules]="themeStyleOverrides" [id]="'main-header-styles'">
</ng-template>
<header role="banner" [ngClass]="[
		'theme-' + currentTheme,
		$state.includes(PORTAL_VIDEO_PLAYBACK_STATE) ? 'no-border' : '',
		!$state.includes(PORTAL_DASHBOARD_STATE) ? 'theme-accent-border' : ''
	]" (vbOffsetHeightModel)="MainHeaderPosition.setHeight($event.offsetHeight)">
	@if (ThemeService.brandingSettings.headerSettings.bannerImageUri) {
		<img class="banner-image theme-header" [style.height.px]="ThemeService.brandingSettings.headerSettings.bannerImageHeight" [src]="ThemeService.brandingSettings.headerSettings.bannerImageUri" vbImageLoad>
	}
	@switch (currentTheme) {
		@case (BrandingHeaderType.Classic) {
			<classic-header [mainContent]="mainContent" [isGuestMode]="isGuestMode">
			</classic-header>
		}
		@case (BrandingHeaderType.Nettrix) {
			<nettrix-header [mainContent]="mainContent" [isGuestMode]="isGuestMode">
			</nettrix-header>
		}
		@case (BrandingHeaderType.TwoTier) {
			<twotier-header [mainContent]="mainContent" [isGuestMode]="isGuestMode">
			</twotier-header>
		}
	}
</header>
